import DOMPurify from 'dompurify';

export const sanitizeSVG = (svgString: string): string => {
  return DOMPurify.sanitize(svgString, {
    USE_PROFILES: { svg: true, svgFilters: true },
    FORBID_TAGS: [
      'script',
      'foreignObject',
      'use',
      'embed',
      'iframe',
      'object',
      'link',
      'style',
      'animate',
      'animateMotion',
      'animateTransform',
      'set',
    ],
    FORBID_ATTR: [
      'onload',
      'onerror',
      'onclick',
      'onmouseover',
      'onmouseout',
      'onmousedown',
      'onmouseup',
      'onfocus',
      'onblur',
      'onchange',
      'onsubmit',
      'onreset',
      'onselect',
      'onabort',
      'oninput',
      'onkeydown',
      'onkeypress',
      'onkeyup',
      'onbegin',
      'onend',
      'onrepeat',
      'href',
      'xlink:href',
      'src',
      'action',
      'formaction',
    ],
    KEEP_CONTENT: false,
  });
};
